import React from 'react';
import { COLORS } from '../../../styles/tokens';
import { estimateMinutes } from '../../../utils/priceSuggestion';

const W = 360;
const H = 220;
const PAD = 44;

// Plasserer hente- og leveringspunkt i kortet (skjematisk, ingen kartbibliotek).
export function routePoints(pickup, delivery) {
  const midLat = ((pickup.lat + delivery.lat) / 2) * Math.PI / 180;
  const dx = (delivery.lng - pickup.lng) * Math.cos(midLat);
  const dy = delivery.lat - pickup.lat; // nord er opp
  const span = Math.max(Math.abs(dx), Math.abs(dy));
  if (span < 1e-9) return { a: { x: PAD, y: H - PAD }, b: { x: W - PAD, y: PAD } };
  const scale = Math.min((W - 2 * PAD) / (Math.abs(dx) || 1e-9), (H - 2 * PAD) / (Math.abs(dy) || 1e-9));
  const s = Math.min(scale, 1e9);
  const cx = W / 2, cy = H / 2;
  return {
    a: { x: cx - (dx * s) / 2, y: cy + (dy * s) / 2 },
    b: { x: cx + (dx * s) / 2, y: cy - (dy * s) / 2 },
  };
}

// Kortet med buet, stiplet rute og pillen «14,2 km · ca. 25 min».
export default function RouteCard({ pickup, delivery, distKm }) {
  const { a, b } = routePoints(pickup, delivery);
  const mx = (a.x + b.x) / 2, my = (a.y + b.y) / 2;
  const nx = -(b.y - a.y), ny = b.x - a.x;
  const len = Math.hypot(nx, ny) || 1;
  const bend = Math.min(40, len * 0.25);
  const c = { x: mx + (nx / len) * bend, y: my + (ny / len) * bend };
  const minutes = estimateMinutes(distKm);

  return (
    <div style={styles.card}>
      <svg viewBox={`0 0 ${W} ${H}`} width="100%" height="100%" preserveAspectRatio="xMidYMid slice" role="img" aria-label="Rute mellom hente- og leveringssted">
        <rect width={W} height={H} fill={COLORS.surfaceHover} />
        {[40, 90, 150, 200].map(y => <path key={y} d={`M0 ${y} Q 120 ${y - 24} 240 ${y + 6} T ${W} ${y - 8}`} stroke={COLORS.border} strokeWidth="8" fill="none" opacity="0.7" />)}
        {[70, 160, 260].map(x => <path key={x} d={`M${x} 0 Q ${x + 24} 110 ${x - 10} ${H}`} stroke={COLORS.border} strokeWidth="6" fill="none" opacity="0.6" />)}
        <path d={`M${a.x} ${a.y} Q ${c.x} ${c.y} ${b.x} ${b.y}`} stroke={COLORS.brandPanel} strokeWidth="3.5" fill="none" strokeDasharray="7 6" strokeLinecap="round" />
        <circle cx={a.x} cy={a.y} r="8" fill={COLORS.brandPanel} stroke="#fff" strokeWidth="3" />
        <circle cx={b.x} cy={b.y} r="8" fill={COLORS.accent} stroke={COLORS.brandPanel} strokeWidth="3" />
      </svg>
      <div style={styles.pill}>
        {distKm.toLocaleString('nb-NO', { minimumFractionDigits: 1, maximumFractionDigits: 1 })} km
        {minutes != null && <span style={{ color: COLORS.textMid, fontWeight: 500 }}> · ca. {minutes} min</span>}
      </div>
    </div>
  );
}

const styles = {
  card: { position: 'relative', height: 220, borderRadius: 18, overflow: 'hidden', marginTop: 8, border: `1px solid ${COLORS.border}` },
  pill: {
    position: 'absolute', left: 12, bottom: 12, background: '#fff', color: '#1a1a2e', borderRadius: 99,
    padding: '8px 14px', fontWeight: 700, fontSize: 14, boxShadow: '0 4px 12px rgba(14,14,28,.15)',
  },
};
